import store from 'client/store';

export default {
  path: 'sessions',
  component: () => import(/* webpackChunkName: "event" */ './wrapper.vue'),
  children: [{
    path: '/',
    name: 'event.discipline.sessions',
    component: () => import(/* webpackChunkName: "event" */ './planningWrapper.vue'),
  }, {
    path: 'config',
    name: 'event.discipline.sessions.planning.config',
    component: () => import(/* webpackChunkName: "event" */ './planningConfig.vue'),
  }, {
    path: 'bib',
    name: 'event.discipline.sessions.bib',
    component: () => import(/* webpackChunkName: "event" */ './bibAssignment.vue'),
  }, {
    path: 'createSubdivisions',
    name: 'event.discipline.sessions.createSubdivisions',
    component: () => import(/* webpackChunkName: "event" */ './createSubdivisions.vue'),
  }, {
    path: 'createOrder',
    name: 'event.discipline.sessions.createOrder',
    component: () => import(/* webpackChunkName: "event" */ './createOrder.vue'),
  }, {
    path: 'checkOrder',
    name: 'event.discipline.sessions.checkOrder',
    component: () => import(/* webpackChunkName: "event" */ './checkOrder.vue'),
  }, {
    path: 'add',
    name: 'event.discipline.sessions.add',
    component: () => import(/* webpackChunkName: "event" */ './add.vue'),
  }, {
    path: ':sessionId',
    name: 'event.discipline.sessions.view',
    component: () => import(/* webpackChunkName: "event" */ './view.vue'),
  },{
    path: ':sessionId/order',
    name: 'event.discipline.sessions.order',
    component: () => import(/* webpackChunkName: "event" */ './order.vue'),
    children: [{
      path: ':set',
      name: 'event.discipline.sessions.order.set',
      component: () => import(/* webpackChunkName: "event" */ './orderSet.vue'),
    },{
      path: 'mixed',
      name: 'event.discipline.sessions.order.mixed',
      component: () => import(/* webpackChunkName: "event" */ './orderMixed.vue'),
    },{
      path: 'block/:blockId',
      name: 'event.discipline.sessions.order.rotations',
      component: () => import(/* webpackChunkName: "event" */ './orderPerRotation.vue'),
    }],
  }, {
    path: ':sessionId/panels',
    component: () => import(/* webpackChunkName: "event" */ '@/app/event/panels/wrapper.vue'),
    beforeEnter: function (to, from, next) {
      store.dispatch('panels.getBySession', { sessionId: to.params.sessionId }).then(next)
    },
    children: [{
      path: '/',
      name: 'event.discipline.sessions.panels',
      component: () => import(/* webpackChunkName: "event" */ '@/app/event/panels/sessionPanels.vue'),
    }, {
      path: ':panelId',
      name: 'event.discipline.sessions.panel',
      component: () => import(/* webpackChunkName: "event" */ '@/app/event/panels/panel.vue'),
    }],
  }],
}
